export const producerVendorOptions = [
  {
    guid: 'true',
    name: 'Отечественный',
  },
  {
    guid: 'false',
    name: 'Зарубежный',
  },
];
